<template>
  <ul class="navi navi-hover py-4">
    <template v-for="(item, i) in languages">
      <li class="navi-item" :class="{ 'navi-item-active': isActiveLanguage(item.lang) }" :key="i">
        <a href="#" class="navi-link" v-bind:data-lang="item.lang" v-on:click="selectedLanguage">
          <span class="symbol symbol-25 mr-3">
            <img :src="item.flag" alt="" class="" />
          </span>
          <span class="navi-text">{{ item.name }}</span>
        </a>
      </li>
    </template>
  </ul>
</template>

<script>
import i18nService from "@/core/services/i18n.service.js";
import ApiService from "@/core/services/api.service";
import BearerService from "@/core/services/bearer.service";

export default {
  name: "KTDropdownLanguage",
  data() {
    return {
      languages: i18nService.languages,
    };
  },
  methods: {
    selectedLanguage(e) {
      const el = e.target.closest(".navi-link");
      const language = el.getAttribute("data-lang");

      this.$emit(
        "language-changed",
        this.languages.find((val) => {
          return val.lang === language;
        })
      );
      i18nService.setActiveLanguage(language);

      if (BearerService.isAuthenticated()) {
        ApiService.post("me/language", { language })
          // eslint-disable-next-line no-unused-vars
          .then((user) => {
            window.location.reload();
          });
      } else {
        window.location.reload();
      }
    },
    isActiveLanguage(current) {
      return this.activeLanguage === current;
    },
  },
  computed: {
    activeLanguage() {
      return i18nService.getActiveLanguage();
    },
  },
};
</script>
